
import { isObject } from './is.js'

function inheritIfRequired ($this, dummy, Wrapper) {
  let NewTarget, NewTargetPrototype
  if (
    Object.setPrototypeOf &&
    typeof (NewTarget = dummy?.constructor) === 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) {
    Object.setPrototypeOf($this, NewTargetPrototype)
  }
  return $this
}

function tryParseInt (value) {
  try {
    const out = parseInt(value)
    return out || value
  } catch (err) {
    return val
  }
}

/**
 *
 * @param {unknown} value
 * @returns {number}
 */
export default function Integer (value) {
  let number

  switch (typeof value) {
    case 'string':
      number = tryParseInt(value)
      break
    case 'number':
      number = value
      break
    default:
      number = Number(value || 0)
      break
  }

  if (Number.isNaN(number)) return 0
  if (number === 0) return 0
  number = Math.trunc(number)

  if (number > Integer.MAX_SAFE_INTEGER) {
    throw new Error('value is exceeds Integer.MAX_SAFE_INTEGER')
  }

  if (number < Integer.MIN_SAFE_INTEGER) {
    throw new Error('value is under Integer.MIN_SAFE_INTEGER')
  }

  if (this instanceof Integer || (this && this.constructor && this.constructor.name === 'Integer')) {
    return inheritIfRequired(Object(number), number, Integer)
  }

  return number
}

Integer.MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF
Integer.MIN_SAFE_INTEGER = -0x1FFFFFFFFFFFFF
Integer.prototype = Number.prototype
Integer.prototype[Symbol.toStringTag] = 'Integer'

Integer.isSafe = function (number) {
  number = Number(number || 0)
  return number < Integer.MAX_SAFE_INTEGER && number > Integer.MIN_SAFE_INTEGER
}
